
export default {
    SET_BANK_ACCOUNT_LIST(state, item) {
        state.bankAccountList = item;
    },
};
